import type { Item } from '@facile-it/shark-morph/components/FlexView/Item'
import type { Unit } from '../Unit'

export const buildItemProps = (view: Unit.ViewType | undefined): Item.Props => {
    if (!view || typeof view.col === 'undefined') {
        return { xs: 12, lg: 6 }
    }

    const { col } = view
    if (typeof col === 'object') {
        return { ...col }
    }

    return { xs: col }
}
